import React from "react";
import { Helmet } from "react-helmet-async";
import HomeHero from "../../Components/home/homehero/HomeHero";
import HomeBrands from "../../Components/home/homebrands/HomeBrands";
import HomeAbout from "../../Components/home/homeabout/HomeAbout";
import HomeVideo from "../../Components/home/homevideo/HomeVideo";
import HomeFocusSector from "../../Components/home/homefocussector/HomeFocusSector";
import HomeStatistics from "../../Components/home/homestatistics/HomeStatistics";
import HomeSpeakers from "../../Components/home/homespeakers/HomeSpeakers";
import HomeOurPartner from "../../Components/home/homeourpartner/HomeOurPartner";
import { useHomeContext } from "../../context/Home_context";
import Loader from "../../Common/loader/Loader";

const HomePage = () => {
  const { current_expo_loading, current_expo_data } = useHomeContext();

  const isHomeLoading =
    current_expo_loading ||
    !current_expo_data ||
    Object.keys(current_expo_data).length === 0;

  return (
    <>
      <Helmet>
        <title>
          Bharat Buildcon | Building Material & Construction Exhibition in India
        </title>
      </Helmet>
      {isHomeLoading ? (
        <Loader fullScreen={true} text="Loading Bharat Buildcon..." />
      ) : (
        <>
          <HomeHero />
          <HomeAbout />
          <HomeStatistics />
          <HomeFocusSector />
          <HomeVideo />
          <HomeBrands />
          <HomeSpeakers />
          <HomeOurPartner />
        </>
      )}
    </>
  );
};

export default HomePage;
